import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

import { IInboundEmailLog } from 'src/services/inbound-email/inbound-email.types';

type Props = {
  open: boolean;
  onClose: () => void;
  log: IInboundEmailLog | null;
};

export default function ViewParsedDataModal({ open, onClose, log }: Props) {
  if (!log) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Inbound message details</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Stack direction="row" spacing={4}>
            <Box>
              <Typography variant="caption" color="text.secondary">Received</Typography>
              <Typography variant="body2">{new Date(log.created_at).toLocaleString()}</Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">Status</Typography>
              <Typography variant="body2">{log.status}</Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">From</Typography>
              <Typography variant="body2">{log.from_email}</Typography>
            </Box>
          </Stack>

          {log.error_detail && (
            <Box>
              <Typography variant="caption" color="text.secondary">Details</Typography>
              <Typography variant="body2">{log.error_detail}</Typography>
            </Box>
          )}

          <Divider />

          <Box>
            <Typography variant="subtitle2" gutterBottom>Parsed data</Typography>
            {log.parsed_data ? (
              <Box
                component="pre"
                sx={{
                  m: 0,
                  p: 2,
                  bgcolor: 'background.neutral',
                  borderRadius: 1,
                  fontFamily: 'monospace',
                  fontSize: 12,
                  overflowX: 'auto',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {JSON.stringify(log.parsed_data, null, 2)}
              </Box>
            ) : (
              <Typography variant="caption" color="text.disabled">
                No parsed data (message has not been processed or parsing failed before extraction).
              </Typography>
            )}
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary">Message ID</Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: 12, wordBreak: 'break-all' }}>
              {log.nylas_message_id}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
